import Vue from 'vue'

export default {
  list(companyId) {
    return Vue.http.get(`app-services/v2/feature-flags/${companyId || 'resolved'}`)
  }
}
